var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    transform: "matrix(-1 0 0 1 124 5)",
    fill: "#680005"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 64.5C129 77.2569 125.217 89.7273 118.13 100.334C111.042 110.941 100.969 119.208 89.1831 124.09C77.3973 128.972 64.4285 130.249 51.9167 127.761C39.4049 125.272 27.9121 119.129 18.8916 110.108C9.87115 101.088 3.72812 89.5951 1.23938 77.0833C-1.24937 64.5715 0.0279457 51.6027 4.9098 39.8169C9.79165 28.0311 18.0588 17.9576 28.6657 10.8702C39.2727 3.78286 51.7431 0 64.5 0C81.6065 0 98.0123 6.79551 110.108 18.8916C122.204 30.9877 129 47.3935 129 64.5ZM101.357 59.8928H45.3804L71.0882 34.0606L64.5 27.6429L27.6429 64.5L64.5 101.357L71.0882 94.7827L45.3804 69.1071H101.357V59.8928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevBtn);
export default __webpack_public_path__ + "static/media/PrevBtn.177ab53f6dde7238f3aa9e2f6f8053ca.svg";
export { ForwardRef as ReactComponent };